import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './router/guard'
import './assets/styles/themes/variables.css'
import './assets/styles/global.css'
import './assets/iconfont/iconfont.css'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
